module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Loading-b4032f6a2d807aea9bd7ad3f4243c257.svg";